import { CommonToolTip, NoRecordFound } from "components/Common/Common";
import { Button, Col, Row } from "react-bootstrap";
import formIcn from "Assets/images/formIcn.svg";
import LoadingOverlay from "./LoadingOverlay";
import { useLazyGetFileUrlQuery } from "store/services/utility";
import AddDocumentPop from "components/Modals/AddDocumentPop";
import { useEffect, useState } from "react";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { useDeleteResourceMutation, useRestoreResourceMutation } from "store/services/resource";
import { convertToMomentDate, dateFormat, successMessageToast } from "helpers/common";
import { cloneDeep } from "lodash";
import parse from "html-react-parser";
import { generatePath, useNavigate } from "react-router-dom";
import { VIEW_REPORT } from "config/paths";
import { DeleteIcon, RefreshIcon, ViewDocumentIcon } from "Assets/icons";

const Attachments = ({ resources, uploadDocuments }) => {

    const navigate = useNavigate();

    const [showDocumentModal, setShowDocumentModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showRestoreModal, setShowRestoreModal] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [resourcesList, setResourcesList] = useState([]);

    const reports = resourcesList?.filter(x => x.type == "report");
    const attachments = resourcesList?.filter(x => x.type == "attachment");

    const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();
    const [removeFileApi, { isLoading: isRemoving }] = useDeleteResourceMutation();
    const [restoreFile, { isLoading: restoreFileLoading }] = useRestoreResourceMutation();

    const handleViewPdf = async (name) => {

        try {
            const result = await getFileUrl(name);
            if (result?.error) return;

            const url = result?.data
            if (url) window.open(url, '_blank');

        } catch (err) { console.error("Error assigning therapist", err); }
    };

    const handleDelete = async () => {

        try {
            setShowDeleteModal(false);

            const list = cloneDeep(resourcesList);
            const index = list.findIndex(x => x.id == currentItem?.id);

            if (index > -1) {

                list[index] = { ...list[index], deletedAt: new Date() };
                setResourcesList(list);
                const result = await removeFileApi(currentItem?.id);
                if (result?.error) return;

                successMessageToast(result?.data?.message);
            };
        } catch (err) { console.error("Error deleting document", err); }
    };

    const handleRestore = async () => {

        try {
            setShowRestoreModal(false);

            const list = cloneDeep(resourcesList);
            const index = list.findIndex(x => x.id == currentItem?.id);

            if (index > -1) {

                list[index] = { ...list[index], deletedAt: null };
                setResourcesList(list);
                const result = await restoreFile(currentItem?.id);
                if (result?.error) return;

                successMessageToast(result?.data?.message);
            };
        } catch (err) { console.error("Error restoring document", err); }
    };

    useEffect(() => {

        if (resources?.length) setResourcesList(resources);
    }, [resources]);

    return (
        <div>
            <ConfirmationPop
                confirmation={showDeleteModal}
                setConfirmation={setShowDeleteModal}
                confirmHandler={handleDelete}
                type={"delete"}
            />

            <ConfirmationPop
                confirmation={showRestoreModal}
                setConfirmation={setShowRestoreModal}
                confirmHandler={handleRestore}
                type={"restore"}
            />

            <AddDocumentPop
                show={showDocumentModal}
                setShow={setShowDocumentModal}
                handleSubmit={(values) => {
                    setShowDocumentModal(false)
                    uploadDocuments(values);
                }}
            />
            {(getFileLoading || getFileFetching || isRemoving || restoreFileLoading) && <LoadingOverlay />}
            <Row>
                <Col lg="12" className="my-2">
                    <div className="d-flex justify-content-between">
                        <h5 className="m-0 themeBlue fw-bold pb-2">Attachments:</h5>
                        <Button
                            className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent"
                            onClick={() => setShowDocumentModal(true)}
                        >
                            Add Attachment
                        </Button>
                    </div> 
                    <div
                        style={{ maxHeight: "300px", overflowY: "auto" }}
                        className={`tableResponsive table-responsive mb-3 pb-0`}
                    >
                        {!attachments?.length ? <NoRecordFound /> : <table className={`table mb-0`}>
                            <thead className="sticky">
                                <tr>
                                    <th className="m-0 themeBlue fw-bold p-1 bg-transparent">Document</th>
                                    <th className="m-0 themeBlue fw-bold p-1 bg-transparent">Date</th>
                                    <th className="m-0 themeBlue fw-bold p-1 bg-transparent"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    attachments?.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td style={{ width: "80%" }} className="">
                                                    <div className="d-flex align-items-center gap-10">
                                                        <span className="icn flex-shrink-0">
                                                            <img
                                                                src={formIcn}
                                                                alt=""
                                                                className="img-fluid"
                                                            />
                                                        </span>
                                                        <CommonToolTip
                                                            text={item?.attachment_name}
                                                            component={
                                                                <p style={{ maxWidth: "250px", textOverflow: "ellipsis", overflow: "hidden" }} className="m-0 p-0" role="button" onClick={() => handleViewPdf(item?.attachment_key)}>{item?.attachment_name || "--"}</p>
                                                            }
                                                        />
                                                    </div>
                                                </td>
                                                <td className="">{dateFormat(item?.createdAt)}</td>
                                                <td className="">
                                                    <div className="d-flex align-items-center gap-10">
                                                        <div style={{ backgroundColor: "#ebffeb", padding: "6px", borderRadius: "100px" }}>
                                                            <CommonToolTip
                                                                text={"View"}
                                                                component={
                                                                    <ViewDocumentIcon
                                                                        style={{ width: "15px", height: "15px" }}
                                                                        onClick={() => handleViewPdf(item?.attachment_key)}
                                                                        className="cursor-pointer"

                                                                    />}
                                                            />
                                                        </div>
                                                        <div style={{ backgroundColor: "#ebffeb", padding: "6px", borderRadius: "100px" }}>
                                                            {
                                                                !item?.deletedAt ? <CommonToolTip
                                                                    text={"Delete"}
                                                                    component={
                                                                        <DeleteIcon
                                                                            className="cursor-pointer"
                                                                            onClick={() => {
                                                                                setCurrentItem(item);
                                                                                setShowDeleteModal(true);
                                                                            }}
                                                                        />
                                                                    }
                                                                />
                                                                    :
                                                                    <CommonToolTip
                                                                        text={"Retrive"}
                                                                        component={
                                                                            <RefreshIcon
                                                                                className="cursor-pointer mx-1"
                                                                                onClick={() => {
                                                                                    setCurrentItem(item);
                                                                                    setShowRestoreModal(true);
                                                                                }}
                                                                            />
                                                                        }
                                                                    />
                                                            }
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>}
                    </div>
                    <div className="my-2">
                        <h6 className="m-0 themeBlue fw-bold my-3">Reports:</h6>
                    </div>
                    <div
                        style={{ maxHeight: "300px", overflowY: "auto" }}
                        className={`tableResponsive table-responsive  pb-0`}
                    >
                        {!reports?.length ? <NoRecordFound /> : <table className={`table mb-0`}>
                            <thead className="sticky">
                                <tr>
                                    <th className="m-0 themeBlue fw-bold p-1 bg-transparent">Report Name</th>
                                    <th className="m-0 themeBlue fw-bold p-1 bg-transparent">Discipline</th>
                                    <th className="m-0 themeBlue fw-bold p-1 bg-transparent">Date</th>
                                    <th className="m-0 themeBlue fw-bold p-1 bg-transparent"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    reports?.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td className="">
                                                    <div className="d-flex align-items-center gap-10">
                                                        <span className="icn flex-shrink-0">
                                                            <img
                                                                src={formIcn}
                                                                alt=""
                                                                className="img-fluid"
                                                            />
                                                        </span>
                                                        <CommonToolTip
                                                            text={item?.attachment_name}
                                                            component={
                                                                <p style={{ maxWidth: "250px", textOverflow: "ellipsis", overflow: "hidden" }} className="m-0 p-0" role="button" onClick={() => handleViewPdf(item?.attachment_key)}>{parse(item?.attachment_name) || "--"}</p>
                                                            }
                                                        />
                                                    </div>
                                                </td>
                                                <td className="">{item?.therapistResources?.therapist_detail?.therapist_discipline?.assign_term}</td>
                                                <td className="">{dateFormat(item?.createdAt)}</td>
                                                <td className="">
                                                    <div className="d-flex align-items-center gap-10">
                                                        <div style={{ backgroundColor: "#ebffeb", padding: "6px", borderRadius: "100px" }}>
                                                            <CommonToolTip
                                                                text={"View"}
                                                                component={
                                                                    <ViewDocumentIcon
                                                                        style={{ width: "15px", height: "15px" }}
                                                                        className="cursor-pointer"
                                                                        onClick={() => navigate(generatePath(VIEW_REPORT, { attachmentKey: item.attachment_key }))}
                                                                    />
                                                                }
                                                            />
                                                        </div>
                                                        <div style={{ backgroundColor: "#ebffeb", padding: "6px", borderRadius: "100px" }}>
                                                            {
                                                                !item?.deletedAt ? <CommonToolTip
                                                                    text={"Delete"}
                                                                    component={
                                                                        <DeleteIcon
                                                                            className="cursor-pointer"
                                                                            onClick={() => {
                                                                                setCurrentItem(item);
                                                                                setShowDeleteModal(true);
                                                                            }}
                                                                        />
                                                                    }
                                                                />
                                                                    :
                                                                    <CommonToolTip
                                                                        text={"Retrive"}
                                                                        component={
                                                                            <RefreshIcon
                                                                                className="cursor-pointer mx-1"
                                                                                onClick={() => {
                                                                                    setCurrentItem(item);
                                                                                    setShowRestoreModal(true);
                                                                                }}
                                                                            />
                                                                        }
                                                                    />
                                                            }
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>}
                    </div>
                </Col>
            </Row>
        </div>
    )
};

export default Attachments;